import React, { useReducer, useContext } from "react";
import { coachPoolTeamsReducer as reducer } from "../reducers/coachPoolTeamsReducer";
import { coachPoolTeamsActions as actions } from "../actions/coachPoolTeamsActions";

const initialValue = {
  coachPool: null,
  teams: null,
};

const coachPoolTeamsContext = React.createContext();

const CoachPoolTeamsContext = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <coachPoolTeamsContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </coachPoolTeamsContext.Provider>
  );
};

export const useCoachPoolTeamsContext = () =>
  React.useContext(coachPoolTeamsContext);
export default CoachPoolTeamsContext;
